import { z } from 'zod';
export const NotesParameterSchema = z.enum(['NOTES_BASE_URL']);
export const NotesParameterEnum = NotesParameterSchema.enum;
